import styled from 'styled-components';
import { Flex } from '@ui-library/flex';

export const ErrorContainer = styled(Flex)`
  color: ${({ theme }) => theme.token.colorError};
  background-color: ${({ theme }) => theme.token.colorErrorBg};
  border-radius: ${({ theme }) => theme.token.borderRadius}px;
  overflow: hidden;
  padding: ${({ theme }) => theme.token.paddingXS}px;
`;

export const ErrorEditor = styled.div`
  width: 100%;
  border: unset;

  .monaco-editor .margin,
  .monaco-editor-background {
    background-color: ${({ theme }) => theme.token.colorErrorBg} !important;
  }
`;
